import { GridColDef } from "@material-ui/data-grid";
import { useEffect } from "react";
import { ReactNode, useState } from "react";
import { createContext } from "react";
import { orderByFieldGeneration } from "../lib";
import { TimePointProjectUsers } from "../model";

interface RoutineAppointmentProviderProps {
  children: ReactNode;
}

interface RoutineAppointmentContextProps {
  rows: any;
  setRows: (value: any) => void;
  selectProject: any;
  setSelectProject: any;
  initialValue: any;
  setInitialValue: any;
  columns: any;
  orderByField: any;
  stateSwitch: boolean;
  setStateSwitch: (value: boolean) => void;
  page: any;
  setPage: any;
  selectSize: any;
  setSelectSize: any;
  listRender;
}

const columns: GridColDef[] = [
  {
    field: "userName",
    headerName: "Nome",
  },
  {
    field: "clientName",
    headerName: "Cliente",
    // width: 300,
  },
  {
    field: "projectName",
    headerName: "Projeto",
    // width: 300,
  },
  {
    field: "allocationTime",
    headerName: "Alocação por Projeto",
    // width: 300,
  },
  {
    field: "workedTime",
    headerName: "Total de horas",
    // width: 300,
  },
];

export const RoutineAppointmentContext = createContext({} as RoutineAppointmentContextProps);

export function RoutineAppointmentProvider({ children }: RoutineAppointmentProviderProps) {
  const [rows, setRows] = useState([] as TimePointProjectUsers[]);
  const [listRender, setListRender] = useState([] as TimePointProjectUsers[]);
  const [selectProject, setSelectProject] = useState(false);
  const [initialValue, setInitialValue] = useState([] as any[]);
  const [stateSwitch, setStateSwitch] = useState(false);

  const orderByField = orderByFieldGeneration(columns);

  const [page, setPage] = useState(1);
  const [selectSize, setSelectSize] = useState(10);

  useEffect(() => {
    let arrRender = [];
    let arrNotRender = [];
    rows?.forEach((row) => {
      if (row?.consolidatedHours === stateSwitch) arrRender.push(row);
      else arrNotRender.push(row);
    });
    setListRender(arrRender);
  }, [stateSwitch, rows]);

  return (
    <RoutineAppointmentContext.Provider
      value={{
        rows,
        setRows,
        selectProject,
        setSelectProject,
        initialValue,
        setInitialValue,
        columns,
        orderByField,
        stateSwitch,
        setStateSwitch,
        page,
        setPage,
        selectSize,
        setSelectSize,
        listRender,
      }}
    >
      {children}
    </RoutineAppointmentContext.Provider>
  );
}
